import { Show, Suspense, createSignal, lazy, onCleanup, onMount, splitProps } from "solid-js";

// The payment badges are ~33KB of inline SVG strings that sit below the add-to-bag CTA, so the
// hero only fetches them once their slot comes near the viewport (or right away without IO support).
const PaymentIconsGroup = lazy(() => import("./PaymentIconsGroup").then((module) => ({ default: module.PaymentIconsGroup })));
const MOUNT_ROOT_MARGIN = "400px 0px";
const DEFAULT_ICON_SIZE = 40;

export const LazyPaymentIconsGroup = (props) => {
  let mountRef;
  // layout classes (width / margin) go on the slot so the reserved box matches the mounted row
  const [layout, iconProps] = splitProps(props, ["class"]);
  const [near, setNear] = createSignal(typeof IntersectionObserver === "undefined");

  onMount(() => {
    if (!mountRef || near()) return;
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      setNear(true);
    }, { rootMargin: MOUNT_ROOT_MARGIN });
    observer.observe(mountRef);
    onCleanup(() => observer.disconnect());
  });

  // reserve the icon row's height so the badges don't push the content below them when they mount
  const reservedHeight = () => `${Number(props.size ?? DEFAULT_ICON_SIZE)}px`;

  return (
    <div ref={mountRef} class={layout.class} style={{ "min-height": reservedHeight() }}>
      <Show when={near()}>
        <Suspense fallback={null}>
          <PaymentIconsGroup {...iconProps} />
        </Suspense>
      </Show>
    </div>
  );
};
